import { emit } from './store-events.js';

class StoreQuantitySync extends HTMLElement {
  constructor() {
    super();
    this._onInput = this._onInput.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    try {
      this._input = this._findQuantityInput();
      this._cardsRoot = this._findCardsRoot();

      // ARIA roles for accessibility and Tailwind aria-checked variants
      try { if (this._cardsRoot && !this._cardsRoot.getAttribute('role')) this._cardsRoot.setAttribute('role', 'radiogroup'); } catch (_) {}
      try {
        const buttons = this._cardsRoot ? this._cardsRoot.querySelectorAll('button[data-quantity]') : [];
        buttons && buttons.forEach && buttons.forEach((btn) => { if (!btn.getAttribute('role')) btn.setAttribute('role', 'radio'); });
      } catch (_) {}

      if (this._input) {
        try { this._input.addEventListener('input', this._onInput); } catch (_) {}
        try { this._input.addEventListener('change', this._onInput); } catch (_) {}
      }
      try { this.addEventListener('click', this._onClick); } catch (_) {}

      // Initial sync: input → cards and reflect on add-to-cart
      this._syncCardsFromInput(true);
    } catch (_) {}
  }

  disconnectedCallback() {
    try { if (this._input) { this._input.removeEventListener('input', this._onInput); this._input.removeEventListener('change', this._onInput); } } catch (_) {}
    try { this.removeEventListener('click', this._onClick); } catch (_) {}
  }

  _findQuantityInput() {
    try {
      const local = this.querySelector && this.querySelector('input[name="quantity"], input[type="number"][name="quantity"]');
      if (local) return local;
      const scope = (this.closest && (this.closest('form') || this.closest('[data-product-id]'))) || document;
      return scope && scope.querySelector && scope.querySelector('input[name="quantity"], input[type="number"][name="quantity"]');
    } catch (_) { return null; }
  }

  _findCardsRoot() {
    try {
      const explicit = this.querySelector && this.querySelector('[data-quantity-cards]');
      if (explicit) return explicit;
      const btn = this.querySelector && this.querySelector('button[data-quantity]');
      return btn ? (btn.parentElement || this) : null;
    } catch (_) { return null; }
  }

  _findAddToCart() {
    try {
      const scopeRoots = [];
      try { const form = this.closest && this.closest('form'); if (form) scopeRoots.push(form); } catch (_) {}
      try { const wrap = this.closest && this.closest('[data-product-id]'); if (wrap) scopeRoots.push(wrap); } catch (_) {}
      if (!scopeRoots.length) scopeRoots.push(document);
      for (let i = 0; i < scopeRoots.length; i += 1) {
        const s = scopeRoots[i];
        try { const btn = s.querySelector && s.querySelector('[data-add-to-cart]'); if (btn) return btn; } catch (_) {}
      }
    } catch (_) {}
    return null;
  }

  _onInput() {
    try { this._syncCardsFromInput(false); } catch (_) {}
  }

  _onClick(ev) {
    try {
      const btn = ev.target && ev.target.closest && ev.target.closest('button[data-quantity]');
      if (!btn || (this._cardsRoot && !this._cardsRoot.contains(btn))) return;
      const raw = btn.getAttribute && (btn.getAttribute('data-quantity') || btn.getAttribute('data-qty-set'));
      const next = (() => { try { return Math.max(1, parseInt(raw || '1', 10) || 1); } catch (_) { return 1; } })();
      // Reflect into input
      if (this._input) {
        this._input.value = String(next);
        try { this._input.dispatchEvent(new Event('input', { bubbles: true })); } catch (_) {}
        try { this._input.dispatchEvent(new Event('change', { bubbles: true })); } catch (_) {}
      }
      // Also reflect on nearest add-to-cart for robustness (and Appstle scenarios)
      try { const addBtn = this._findAddToCart(); if (addBtn) addBtn.setAttribute('data-quantity', String(next)); } catch (_) {}
      // Update cards selection immediately for responsiveness
      this._selectCardForValue(next);
      try { emit('store:quantity:change', { quantity: next }, this); } catch (_) {}
    } catch (_) {}
  }

  _syncCardsFromInput(initial) {
    try {
      const val = (() => { try { return Math.max(1, parseInt((this._input && this._input.value) || '1', 10) || 1); } catch (_) { return 1; } })();
      this._selectCardForValue(val);
      // Keep add-to-cart data-quantity in sync on init and input changes
      try { const addBtn = this._findAddToCart(); if (addBtn) addBtn.setAttribute('data-quantity', String(val)); } catch (_) {}
      if (!initial) try { emit('store:quantity:change', { quantity: val }, this); } catch (_) {}
    } catch (_) {}
  }

  _selectCardForValue(val) {
    try {
      if (!this._cardsRoot) return;
      const buttons = Array.from(this._cardsRoot.querySelectorAll('button[data-quantity]'));
      if (!buttons.length) return;
      buttons.forEach((b) => {
        const q = (() => { try { return parseInt(b.getAttribute('data-quantity') || '0', 10) || 0; } catch (_) { return 0; } })();
        const isMatch = q === val;
        if (isMatch) { try { b.focus && b.focus(); } catch (_) {} }
        b.toggleAttribute('data-selected', isMatch);
        b.classList.toggle('selected', isMatch);
        b.setAttribute('aria-checked', isMatch ? 'true' : 'false');
        b.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
        b.tabIndex = isMatch ? 0 : -1;
      });
    } catch (_) {}
  }
}

try { if (!customElements.get('store-quantity-sync')) customElements.define('store-quantity-sync', StoreQuantitySync); } catch (_) {}


